import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon, FilePlusIcon } from 'lucide-react';
import { PermisComposer } from '../components/permis/PermisComposer';
import { PermisDialog } from '../components/permis/PermisDialog';
import { PermisList } from '../components/permis/PermisList';
import { PermitCatalogue } from '../components/permis/PermitCatalogue';
const PANEL_LAYOUT_ID = 'atna-permis-panel';
export function MesPermis() {
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  return <main className="bg-white" data-id="element-2997" data-mp="2i07rbqxoftnj">
      <div className="mx-auto max-w-[1180px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2998" data-mp="2i19euuvvq8m5">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2999" data-mp="2myj3i8bg2g8x">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-3000" data-mp="g8bg6iff8lta">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3001" data-mp="l6cw4uhjw50j" />
          <span aria-current="page" data-id="element-3002" data-mp="tdcgk3dws71m">Mes permis</span>
        </nav>

        <div className="mt-4 flex flex-wrap items-start justify-between gap-4" data-id="element-3003" data-mp="tbhsig7cbytb">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3004" data-mp="pc0nfnvtt3oo">Mes permis</h1>
          <Link to="/mes-permis/formulaire" className="inline-flex shrink-0 items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-3005" data-mp="135ryx1t4axn1">
            <FilePlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-3006" data-mp="katevmlv00gy" />
            Remplir le formulaire classique
          </Link>
        </div>

        <div className="mt-8 max-w-[880px]" data-id="element-3007" data-mp="1vrjl35qa8sak">
          <PermisComposer layoutId={PANEL_LAYOUT_ID} morphing={openedWith !== null} onOpen={setOpenedWith} data-id="element-3008" data-mp="1vufkkyhs3p14" />
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-10" data-id="element-3009" data-mp="1yt61dy6cxk02">
          <PermitCatalogue onSelect={type => setOpenedWith(type.prompt)} data-id="element-3010" data-mp="22u81eh83m033" />
          <PermisList data-id="element-3011" data-mp="27ucjucskh4vy" />
        </div>
      </div>

      <AnimatePresence data-id="element-3012" data-mp="27sjc0u67wemd">
        {openedWith !== null && <PermisDialog key="permis-dialog" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} data-id="element-3013" data-mp="2csnswlb1fbd4" />}
      </AnimatePresence>
    </main>;
}